const cancel = 'Отмена'
const save = 'Сохранить'

export default {

  global: {
    generalError: 'Запрос не может быть обработан. Пожалуйста, перезагрузите страницу.',
    signature: 'С уважением,',
  },

  component: {
    actionBar: {
      actions: 'Действия',
      hideActions: 'Скрыть действия',
    },

    addButton: {
      add: 'Добавить',
    },

    attachments: {
      add: 'Добавьте резюме или другие документы',
      placeholderWithDescription: 'Добавьте запрашиваемые вложения',
      remove: 'Удалить',
      allowedFileTypes: 'Поддерживаемые форматы файлов',
      errors: {
        size: 'Размер файла превышен, максимальный размер файла 5 Мб.',
        empty: 'Файл не содержит никаких данных',
        invalidType: fileType => `К сожалению, файлы формата ${fileType} не допускаются по соображениям безопасности`,
        typeNotWhitelisted: 'К сожалению, файлы в данном формате запрещены.',
      },
    },

    agreeTos: {
      privacyLinkText: 'Политикой конфиденциальности',
      termsLinkText: 'Правила и условия',
      privacyPolicyText:
        'Мы ценим вашу конфиденциальность. Пожалуйста, ознакомьтесь с нашей ',
      termsText1: 'Прочтите и примите ',
      termsText2: 'прежде чем предоставить нам свои личные данные.',
      privacyLink: 'https://new.recright.com/privacy-policy',
      termsLink: 'https://new.recright.com/recright-terms-and-conditions-candidate',
      privacyInfo: mail => `'Если вы не хотите, чтобы нами обрабатывались ваши личные данные, вы можете запросить их удаление, послав сообщение на ${mail}.`,
      customSupportPrivacyInfo: link => `Если вы не согласны с тем, что нами обрабатываются ваши персональные данные, вы можете запросить их удаление, связавшись с нами по ${link}.`,
    },

    buttons: {
      close: 'Закрыть',
    },

    competencies: {
      addCompetency: 'Добавить новый навык',
      edit: 'Редактировать навыки',
      done: 'Готово',
      defaultsDescription: 'Если Вы не определились, какие компетенции хотели бы использовать, Вы можете воспользоваться компетенциями, которые мы установили по умолчанию.',
      getDefaults: 'Получить компетенции по умолчанию',
    },

    competency: {
      warning: 'Удалить навык и оценки?',
    },

    confirmDelete: {
      delete: 'Удалить',
      cancel: 'Отмена',
      confirm: 'Подтвердить',
    },

    confirm: {
      cancel: 'Удалить',
      confirm: 'Попробовать снова',
    },

    confirmButton: {
      wait: count => `Подождите ${count}`,
      confirm: 'Подтвердить',
    },

    controlStatus: {
      text: {
        empty: 'Заполнить',
        valid: () => 'Готово',
      },
      textarea: {
        empty: 'Заполнить',
        valid: (length, limit) => `${length}/${limit}`,
      },
      select: {
        empty: 'Установить',
        valid: () => 'Готово',
      },
      file: {
        empty: 'Выбрать',
        valid: () => 'Изменить',
      },
      list: {
        empty: 'Добавить',
        valid: (length, limit) => `${length}/${limit}`,
      },
      search: {
        empty: 'Поиск',
        valid: () => 'Готово',
      },
    },

    cookieConsentModal: {
      title: 'Наш веб-сайт использует куки',
      body: 'Соглашаясь с использованием всех куки, вы соглашаетесь на сохранение куки на своём устройстве для улучшения навигации по веб-сайту, анализа использования сайта и содействия нашей маркетинговой деятельности.',
      learnMoreLinkText: 'Узнайте больше о том, как мы используем куки',
      learnMoreLink: 'https://new.recright.com/cookies/', // TODO add localized links when the page is translated
      manageCookies: 'Управление куки-файлами',
      acceptAll: 'Принять все куки',
      manageTitle: 'Управление параметрами разрешений',
      necessaryCookiesTitle: 'Необходимые куки',
      necessaryCookiesBody:
        'Эти куки необходимы для функционирования веб-сайта и не могут быть отключены в наших системах.',
      performanceCookiesTitle: 'Куки для отслеживания производительности',
      performanceCookiesBody:
        'Эти куки позволяют нам подсчитывать количество посещений и источников веб-трафика, для оценки и улучшения работы нашего веб-сайта',
      confirmChoices: 'Подтвердить выбранные варианты',
      marketingCookiesTitle: 'Куки для маркетинговых целей',
      marketingCookiesBody:
        'Данные куки используются нами для персонализации рекламы и анализа её эффективности.',
      functionalCookiesTitle: 'Функциональные куки',
      functionalCookiesBody:
        'С файлами «куки» расширяется функциональность веб-сайта. Без этих файлов некоторые функции сайта могут не работать. Куки используются, например, в веб-чате и для сохранения настроек пользователя.',
    },

    emailAddresses: {
      remove: 'Удалить',
      importCsv: 'Import CSV',
      invalidEmails: 'Найдены недействительные адреса электронной почты.',
      maxCsvEntryErrorNotification: amount =>
        `Max ${amount} csv entries allowed`,
      importCsvTooltip:
        'Строки CSV могут содержать либо адрес электронной почты, либо адрес электронной почты и номер телефона. Каждая строка представляет получателя. Телефонные номера должны указываться в международном формате (E.164), например <strong>+358</strong>50xxxxxxx.',
    },

    emailDeliveryStatus: {
      Undetermined: {
        Undetermined: 'Ошибка при отправке сообщения по электронной почте. Проверьте, получил ли адресат отправленное вами сообщение.',
      },
      Permanent: {
        General: 'Не удалось доставить сообщение. Почтовый домен получателя не принял отправленное вами сообщение.',
        NoEmail: 'Указанный адрес электронной почты не существует.',
        Suppressed: 'Сообщение по электронной почте так и не доставлено после нескольких попыток его доставки получателю.',
      },
      Transient: {
        General: 'Ошибка при отправке сообщения по электронной почте. Проверьте, получил ли адресат отправленное вами сообщение.',
        MailboxFull: 'Ящик входящих писем получателя переполнен.',
        MessageTooLarge: 'Размер сообщения превышает допустимый максимум.',
        ContentRejected: 'Контент сообщения не принят доменом получателя.',
        AttachmentRejected: 'Приложение к сообщению не принято доменом получателя.',
      },
    },

    smsDeliveryStatus: {
      notDelivered: 'SMS message added to message queue, waiting for delivery.',
      failed: 'Sending SMS message failed.',
      duplicate: 'Введённый номер уже привязан к одному из соискателей работы в собеседовании.',
    },

    error403: {
      heading: 'Доступ запрещён',
      content: 'Убедитесь, что вам выслано приглашение на просмотр данной вакансии в Recright и что вы вошли в верный аккаунт. Также убедитесь, что работаете с Recright не более, чем в одном окне браузера.',
      link: 'Главная страница',
    },

    error404: {
      heading: 'Страница не найдена',
      content: 'К сожалению, страница, которую Вы искали по данному адресу, не существует. Возможно, Вы перешли по устаревшей ссылке или случайно ввели неверный адрес.',
      link: 'Главная страница',
    },

    error410: {
      heading: 'Вакансия в архиве',
      content: 'Вакансия не может быть показана, в связи с ее закрытием, либо истечением срока подачи заявки.',
      link: 'Главная страница',
    },

    calendarError: {
      heading: 'Connecting calendar failed',
      content: 'We were unable to connect your calendar. Please try again later and if the issue continues please contact our support.',
    },

    flash: {
      starting: 'Инициализация...',
      connection_error_hint: 'Соединение не может быть установлено.\nПопробуйте перезагрузить страницу.',
      permission_hint: 'Вы должны разрешить этому сайту использовать Вашу веб-камеру и микрофон.',
      searching_camera_hint: 'Идет поиск веб-камеры...',
      camera_reserved_hint: 'Другое приложение или интернет-ресурс использует Вашу веб-камеру.\nПожалуйста, закройте это приложение и перезагрузите страницу.',
      camera_reserved_hint_chrome_extra: '\n\nУважаемый пользователь Chrome, Вам нужно разрешить Recright использовать веб-камеру в диалоговом окне под адресной строкой.',
      no_camera_hint: 'Не удается обнаружить веб-камеру.',
      no_mic_hint: 'Не удается обнаружить микрофон.',
      uploading_text: 'Загрузка ...',
      rtmpt_in_use: 'Этот шаг не понадобится, если Ваш сетевой\nадминистратор предоставит разрешение на использование RTMP. Спросите нас, как.',
      preview_text: 'Веб-камера находится в режиме предпросмотра',
      close_text: 'Закрыть камеру',
      remove_text: 'Удалить',
      noflash_errortext_install: link => `Кажется, у Вас не установлен Adobe Flash Player. Для записи видео Вам необходим flash плагин. Скачать здесь: ${link}`,
      noflash_errortext_enable: link => `Если Вы уже установили flash, но все еще видите данное сообщение, загляните сюда: ${link}`,
      noflash_errortext_differentbrowser: 'В качестве альтернативы Вы можете попробовать использовать браузер, поддерживающий запись HTML5. Мы рекомендуем Chrome или Firefox.',
    },

    footer: {
      terms: 'Условия и положения для пользователей Recright',
      license: 'Общие условия оказания услуг Recright',
      privacyPolicy: 'Политика обработки персональных данных',
      customSupport: link => `Свяжитесь с нами по ${link}`,
      accessibilityReport: 'Accessibility report',
    },

    feedbackPulse: {
      howWouldYouRateInterview: 'Оцените, пожалуйста, свои впечатления от собеседования',
      howWouldYouRateJobAd: 'Как вы оцените свои впечатления от процесса поиска работы в нашем сервисе?',
      yourResponseIsAnonymous: 'Вы предоставляете ответ анонимно.',
      thankYouFeedback: 'Спасибо за отзыв!',
    },

    candidateFooter: {
      termsLink: 'https://new.recright.com/recright-terms-and-conditions-candidate',
      privacyPolicyLink: 'https://new.recright.com/privacy-policy',
      accessibilityReportLink: 'https://new.recright.com/hubfs/RecRight_Accessibility_report.pdf',
    },

    formErrors: {
      typeNotWhitelisted: 'К сожалению, файлы в данном формате запрещены.',
      isRequired: 'Это поле является обязательным.',
      isEmail: value => `${value} не является корректным адресом электронной почты.`,
      isDate: value => `${value} не является корректной датой.`,
      invalidUrl: 'URL недействителен.',
      singleHireEndError: 'Разовая подписка не может быть использована более 60 дней.',
      isNotTooOldForLive: 'Срок действия истек.',
      isNotAfterEndDate: 'Выбранная дата не может быть позже истечения срока публикации данного объявления о вакансии.',
      isValidMobilePhone: value => `${value ? `${value} is not` : 'Not'} a valid mobile phone number.`,
      isInternationalPhoneNumber: 'Phone number must be in international format.',
      duplicateNumber: 'Номер телефона уже добавлен.',
      duplicateCompetency: 'Компетенция с таким именем уже существует',
      isNotDuplicateTemplateName:
        'Шаблон сообщения для электронной почты с таким названием уже существует.',
    },

    jobAdApplication: {
      name: 'Имя',
      email: 'Email',
      phone: 'Телефон',
      city: 'Город',
      applyForPosition: 'Откликнуться',
      back: 'Назад',
      continue: 'Продолжить',
      submit: 'Представить',
      saveForLater: 'Продолжить позже',
      namePlaceholder: 'Введите Ваше имя',
      emailPlaceholder: 'Введите Ваш адрес электронной почты',
      cityPlaceholder: 'Введите свой текущий город проживания',
      phonePlaceholder: 'Введите Ваш номер телефона',
      links: 'Добавьте ссылки, например, на Ваш профиль в LinkedIn ',
      legendAdditionalFields: 'Дополнительные данные',
      legendBasicInfo: 'Общие данные',
      legendLinks: 'Ссылки',
      legendAttachments: 'Вложения',
      coverLetter: 'Сопроводительное письмо',
      attachments: 'Вложения',
      introduction: 'Вы можете добавить свои комментарии здес',
      thankYou: 'Спасибо.',
      luck: 'Желаем удачи!',
      close: 'Закрыть',
      required: 'Позиции, обозначенные звездочкой * обязательны для заполнения.',
    },

    jobAdContainer: {
      endTime: date => (date ? `крайний срок подачи анкет ${date}` : ''),
    },

    jobAdDetails: {
      apply: 'Откликнуться',
    },

    jobAdQuickInterview: {
      back: 'Назад',
      submit: 'Представить',
      saveForLater: 'Продолжить позже',
      title: 'Краткое видеоинтервью',
      description: 'Чтобы быстрее познакомиться с Вами, мы просим Вас кратко ответить на вопросы нашего интервью. Проявите индивидуальность с своей анкете.',
      requiredNote: 'Обратите внимание, что это лишь одна из частей процесса отклика, и рекрутер получит Вашу анкету только после того, как Вы запишете свой ответ.',
      reminderNote: 'Вы можете записать ответ сразу же, или  продолжить позже, получив напоминание на свой адрес электронной почты.',
    },

    jobAdRow: {
      responses: 'Отклики',
      status: {
        open: 'Открыта',
        filled: 'Закрыта (выбран финалист)',
        cancelled: 'Отмена',
        done: 'Готово',
        close: 'Закрыть',
        draft: 'Скрыта(черновик)',
        hidden: 'Анонимная',
      },
    },

    interviewRow: {
      responses: 'Кандидаты',
    },

    linkedInProfile: {
      showLinkedInProfileModal: 'Показать профиль LinkedIn',
    },

    linkedInButton: {
      error: 'Ошибка при загрузке профиля. Повторите попытку.',
      buttonText: 'Aplică cu LinkedIn',
    },

    linkedInContainer: {
      linkedInButtonDescription: 'Вы можете использовать свой профиль LinkedIn для автоматического заполнения формы',
      linkedInOr: 'Или',
      error: 'Ошибка при загрузке профиля. Повторите попытку.',
    },

    linkListInput: {
      addField: 'Добавить',
      removeField: 'Удалить',
      invalidUrl: 'URL недействителен.',
    },

    loadingButton: {
      loading: 'Загрузка...',
      saving: 'Сохранение...',
      sending: 'Отправка...',
    },

    modalApplicationForm: {
      applyForPosition: 'Откликнуться на вакансию',
      continue: 'Продолжить',
      name: 'Введите Ваше имя',
      email: 'Введите Ваш адрес электронной почты',
      phoneNumber: 'Введите Ваш номер телефона',
      links: 'Вы можете ввести ссылки',
      legendLinks: 'Ссылки',
      legendAttachments: 'Вложения',
      coverLetter: 'Сопроводительное письмо',
      attachments: 'Вложения',
      introduction: 'Здесь Вы можете добавить свои комментарии',
      thankYou: 'Спасибо.',
      luck: 'Желаем удачи!',
      close: 'Закрыть',
    },

    modalConfirm: {
      cancel,
      confirm: 'OK',
    },

    modalAlert: {
      close: 'Close',
    },

    modalLinkShare: {
      title: 'Ссылка для предоставления общего доступа',
      info: 'Эта ссылка является общедоступной.\nЛюбой, заинтересованный кандидат может ознакомиться с вакансией по ссылке \nи оставить свой отклик.\n Вы будете уведомлены о получении откликов.\n\nЗдесь Вы можете найти ссылку на вакансию:',
    },

    modalVideoAdd: {
      title: 'Добавить новое видео',
      chooseTitle: 'Добавить новое видео',
      titlePlaceholder: 'Введите название видео здесь.',
      cancel,
      save,
    },

    modalVideoUpload: {
      title: 'Добавить новое видео',
      info: 'Максимально допустимый размер видео 500Мб. Мы рекомендуем Вам сжать видеофайлы перед загрузкой, чтобы ускорить время их обработки.',
    },

    modalCandidateInfo: [
      {
        headline: 'Запишите Ваш видеоответ ',
        content: 'неограниченное число раз. Видео будут сохранены сразу после записи, и Вы cможете вернуться к видеоролику по ссылке, которую Вы получили по электронной почте.',
        mobileContent: 'Добавьте к собеседованию видео. Вы сможете наблюдать за процессом загрузки видео на сервер и за прикреплением его к собеседованию. Вы сможете вернуться к видео-собеседованию по ссылке, полученной вами по электронной почте. <br><br><strong>Если при использовании устройства Apple при просмотре видео экран остаётся чёрным, инструкции по устранению данной неполадки вы найдёте <a style="text-decoration: underline;" target="_blank" rel="noopener noreferrer" href="https://support.recright.com/en/articles/11187-recording-doesn-t-work-with-ipad-iphone">здесь</a>.</strong>',
      },
      {
        headline: 'После записи, ',
        content: 'убедитесь, что видео воспроизводится и Ваш голос можно услышать. После того, как Вы нажмете кнопку «Отправить», Ваш ответ будет зафиксирован и Вы больше не сможете его отредактировать.',
      },
      {
        headline: 'Когда Вы закончите с интервью, ',
        content: 'нажмите кнопку  «Отправить ответы и завершить интервью». После этого Вы уже не сможете вернуться к видеоинтервью. Если вы хотите закрыть эту страницу и продолжить интервью позднее, нажмите кнопку «Продолжить позднее».',
      },
      {
        headline: 'Если Вам нужна помощь ',
        content: mailto => `в прохождении видеоинтервью, нажмите кнопку  «помощь» в правом нижнем углу страницы или напишите нам на email ${mailto}.`,
        customContent: link => `Свяжитесь с нами по ${link}`,
      },
    ],

    navigationBar: {
      back: 'Назад',
      dashboard: 'Личный кабинет',
      frontpage: 'Главная страница',
    },

    personDetails: {
      stage: 'Этап',
      namePlaceholder: 'Соискатель',
      contact: 'Связаться',
      links: 'Ссылки',
      attachments: 'Вложения',
      coverLetter: 'Сопроводительное письмо',
      referrer: 'Реферер',
      referrerInfo: 'Веб-сайт, с которого пришел кандидат.',
      noStage: 'без статуса',
      state: {
        invited: 'Отправлено приглашение',
        visited: 'Было посещение',
        incomplete: 'Заполнение не зaкончено',
        completed: 'Заполнение зaкончено',
      },
      headerAdditionalInformation: 'Дополнительные данные',
      lastSeen: time => `Последнее время посещения ${time}.`,
      notVisited: 'Не проходил интервью.',
      scheduledInterview: 'Scheduled interview',
      scheduledInterviewInvitationSent: 'Invited to a meeting',
      scheduledInterviewInvitationExpired: 'Invitation has expired',
      scheduledInterviewInvitationEventCreated: 'Meeting:',
      scheduledInterviewReScheduleMeeting: 'Reschedule meeting',
      otherPersons: count => `Также найдены отклики на ${count} других вакансиях`,
    },

    phoneInput: {
      placeholder: example => `Номер телефона в формате ${example}`,
    },

    questionsAndResponses: {
      response: 'Ответ',
      noResponse: 'Без ответа',
      resetQuestionResponse: 'Удалить ответ кандидата',
      resetQuestionResponseConfirm: questionTitle =>
        `Вы действительно хотите сбросить вопрос "${questionTitle}" и удалить ответ кандидата?`,
      resetQuestionResponseConfirm2:
        'Если вы сделаете это, кандидат сможет заново ответить на данный вопрос.',
    },

    rating: {
      ownVote: 'Ваш рейтинг',
      yourVotePlaceholder: 'Вы еще не проголосовали.',
      totalVotes: count => `Всего оценок: ${count}`,
      mobileModalHeader: 'Добавить оценку',
      noRatings: 'Оценок пока нет',
      yourRatingReset: 'Сбросить',
      averageRating: 'Средний рейтинг',
      reset: 'сброс',
    },

    share: {
      share: 'Поделиться',
      copy: 'Копировать ссылку',
    },

    sort: {
      sort: 'Сортировка',
    },

    supportLink: 'support@recright.ru',

    typeSelect: {
      selected: 'Выбрано',
      change: 'Изменить',
    },

    video: {
      videoNotFound: 'Видео обрабатывается или не найдено',
      retry: 'Повторить попытку',
    },

    videoUpload: {
      uploadPlaceholder: isMobile => (isMobile ? 'Загрузить или записать новое видео' : 'Выбрать файл'),
      videoPlaceholder: 'Записать Ваш ответ',
      uploadPlaceholderCandidate: 'Загрузить свой ответ',
      submit: 'Отправить ответ',
      notAnswered: 'Ответа пока не предоставлено',
      remove: 'Удалить',
      converting: 'Видео конвертируется. Пожалуйста, подождите...',
      uploading: 'Видео загружается. Пожалуйста, подождите...',
      error: {
        invalid: 'Размер выбранного файла слишком велик. Пожалуйста, выберите другой файл.',
        upload: 'Извините, но нам не удалось загрузить видео. Пожалуйста, повторите попытку.',
        transcode: 'Выбранный видеофайл был поврежден или недействителен, повторите попытку.',
      },
    },

    virtualBg: {
      showMoreButtonText: 'Показать больше',
      showLessButtonText: 'Показать меньше',
      infoText1:
        'Во время записи не покидайте страницу и не переключайтесь на другие вкладки! Не пользуйтесь никакими другими приложениями во время записи.',
      infoText2:
        'Фоновое видео лучше всего работают на относительно новых и мощных устройствах.',
      infoText3:
        'Проверьте, что другие приложения не используют микрофон или камеру вашего устройства.',
    },

    videoResponse: {
      videoPlaceholder: 'Запишите Ваш ответ',
      uploadPlaceholder: 'Загрузить свой ответ',
      notAnswered: 'Ответа пока не предоставлено',
      city: 'Введите свой текущий город проживания',
      submit: 'Отправить ответ',
      startInterview: 'Начать интервью',
    },

    webcam: {
      useVideoBgButtonText: 'Использовать фоновое видео',
      removeVideoBgButtonText: 'Удалить фоновое видео',
      starting: 'Включение...',
      close: 'Закрыть камеру',
      remove: 'Удалить',
      record: 'Запись',
      stop: 'Стоп',
      retake: 'Провести собеседование заново',
      submit: 'Отправить ответ',
      converting: 'Видео обрабатывается. Пожалуйста, подождите...',
      uploading: 'Видео загружается. Пожалуйста, подождите...',
      downloading: 'Видео загружается. Пожалуйста, подождите...',
      processing: 'Загрузка...',
      uploadInProgress: 'Передача видео продолжается,пожалуйста, не закрывайте браузер и не покидайте страницу.',
      uploaded: 'Передача видео завершена.',
      error: {
        DevicesNotFoundError: 'Камера либо микрофон недоступны. Пожалуйста, убедитесь, что они включены.',
        NotFoundError: 'Камера либо микрофон недоступны. Пожалуйста, убедитесь, что они включены.',
        NotAllowedError: 'Вы не включили разрешение на использование камеры либо микрофона.',
        PermissionDismissedError: 'Вы не предоставили необходимые разрешения. Пожалуйста, предоставьте разрешение на использование камеры и микрофона.',
        PermissionDeniedError: 'Вы не предоставили разрешение на использование камеры или микрофона.',
        NotReadableError: 'Не удается прочитать запись с камеры либо микрофона. Возможны неполадки с оборудованием.',
        SecurityError: 'Не удается использовать камеру или микрофон из-за ошибки безопасности',
        stream: 'Произошла ошибка. Пожалуйста, перезапустите браузер. Если проблема не будет устранена,пожалуйста, воспользуйтесь другим браузером.',
        download: 'Ошибка загрузки видео. Попробовать еще раз?',
        upload: 'Ошибка загрузки видео. Попробовать еще раз?',
        emptyBlob: 'Память вашего браузера или устройства переполнена, что препятствует записи. Пожалуйста, обновите страницу. Если проблема не будет устранена,пожалуйста, воспользуйтесь другим браузером.',
        alternativeRecorder: 'Файл также можно загрузить, нажав здесь.',
        reconnecting: 'Связь с сетью прервана. Выполняется переподключение.',
      },
    },

    smsMessages: {
      invitationMessage: title =>
        `Здравствуйте! Мы хотели бы пригласить вас на видео-собеседование:  ${title}! Данное приглашение отправлено вам также по электронной почте. `,
    },
  },
  page: {
    interviewPreview: {
      info: 'Это предварительный просмотр собеседования. Видеозапись отключена, данные формы не сохраняются.',
    },
  },
}
